import { useNuxtApp, useRequestHeaders } from "#imports";
export const useSessionOry = async () => {
  const { $ory } = useNuxtApp();
  const { cookie } = useRequestHeaders(["cookie"]);
  const sessionData = (await $ory.toSession(...process.server ? [{ cookie }] : [])).data;
  return sessionData;
};
